import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import './styles/global.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { Toaster } from '@/components/ui/sonner';
import * as Sentry from '@sentry/react';
import { environment } from './utils/environment';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

Sentry.init({
  dsn: 'https://47cad54d629f54968a0b87cd19536ff9@o4509355581112320.ingest.de.sentry.io/4509355588714576',
  sendDefaultPii: true,
  enabled: ['dev', 'uat', 'prod'].includes(environment.sentryEnvironment),
  environment: environment.sentryEnvironment,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  </React.StrictMode>
);
